import { useEffect, useState } from "react";
import { api } from "../../../../components/api/api";
import { Alert, AlertErro } from '../../../../util/Alertas';

export const useGestaoMotoristaVendedor = () => {
    const [pedidos, setPedidos] = useState([]);
    const [pedidosFiltro, setPedidoFiltro] = useState([]);
    const [statusPagamento, setStatusPagamento] = useState([]);
    const [statusPedido, setStatusPedido] = useState([]);
    const [dtInicio, setDtInicio] = useState('');
    const [dtFim, setDtFim] = useState('');
    const [produtos, setProdutos] = useState([]);
    const [nome, setNome] = useState('');
    const [nPedido, setNPedido] = useState('');
    const [vendedores, setVendedores] = useState([]);
    const [vendedorSelecionado, setVendedorSelecionado] = useState(null);
    const [statusPagamentos, setStatusPagamentos] = useState([
        { status_pagamento_id: 1, nome: 'Parcial' },
        { status_pagamento_id: 2, nome: 'Pagamento Concluído' },
        { status_pagamento_id: 3, nome: 'Pagamento Pendente' }
    ]);
    const [statusPagamentosSelecionado, setStatusPagamentosSelecionado] = useState(null);
    const [statusPedidoSelecionado, setStatusPedidoSelecionado] = useState("-1");
    const [linhasSelecionadas, setLinhasSelecionadas] = useState([]);
    const [sortConfig, setSortConfig] = useState({ key: 'data_pedido', direction: 'asc' });
    const [showEditarStatusModal, setShowEditarStatusModal] = useState(false);
    const [pedidoSelecionado, setPedidoSelecionado] = useState(null);
    const [showAssinaturaModal, setShowAssinaturaModal] = useState(false);
    const [pedidoAssinaturaSelecionado, setPedidoAssinaturaSelecionado] = useState(null);
    const [carregando, setCarregando] = useState(true);

    const onChangeFiltroStatusPedido = e => {
        const value = e.target.value;
        setStatusPedidoSelecionado(parseInt(value));
    }

    const BuscarTodosPedidos = () => {
        setPedidos([]);
        setPedidoFiltro([]);
        setCarregando(true);
        api.get(`api/Pedidos/BuscarTodos?q=${nome}&dtInicio=${dtInicio}&dtFim=${dtFim}&nPedido=${nPedido.replaceAll("_", "")}&vendedor=${vendedorSelecionado}&stautsPagamento=${statusPagamentosSelecionado}&statusPedido=${statusPedidoSelecionado}`, res => {
            setCarregando(false);
            setStatusPagamento(res.data.statusPagamento);
            setStatusPedido(res.data.statusPedido);
            setPedidos(res.data.pedidos);

            if (statusPedidoSelecionado == "-1") {
                setPedidoFiltro(res.data.pedidos.filter(x => x.status_pedido_id !== 5 && x.status_pedido_id !== 4));
            } else {
                setPedidoFiltro(res.data.pedidos);

            }

        }, erro => {
            setCarregando(false);
            AlertErro(erro);
        }, true)
    }

    useEffect(() => { BuscarTodosPedidos(); }, []);

    const sortedPedidos = [...pedidos].sort((a, b) => {
        const { key, direction } = sortConfig;
        let aValue = a[key];
        let bValue = b[key];
        if (key.includes('data')) {
            aValue = new Date(aValue);
            bValue = new Date(bValue);
        }

        if (typeof aValue === 'string') {
            aValue = aValue.toLowerCase();
            bValue = bValue.toLowerCase();
        }

        if (aValue < bValue) return direction === 'asc' ? -1 : 1;
        if (aValue > bValue) return direction === 'asc' ? 1 : -1;
        return 0;
    });

    const handleSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };

    const getSortIcon = (key) => {
        if (sortConfig.key !== key) return null;
        return sortConfig.direction === 'asc' ? '▲' : '▼';
    };

    const handleShowEditarStatusModal = (pedido) => {
        setPedidoSelecionado(pedido);
        setShowEditarStatusModal(true);
    };

    const handleHideEditarStatusModal = () => {
        setShowEditarStatusModal(false);
        setPedidoSelecionado(null);
    };

    const handleEditarStatusPedido = (pedidoId, novoStatus) => {
        handleHideEditarStatusModal();
    };

    const handleShowAssinaturaModal = (pedido) => {
        setPedidoAssinaturaSelecionado(pedido);
        setShowAssinaturaModal(true);
    };

    const handleHideAssinaturaModal = () => {
        setShowAssinaturaModal(false);
        setPedidoAssinaturaSelecionado(null);
    };

    return {
        pedidos,
        sortedPedidos,
        pedidosFiltro,
        statusPagamento,
        statusPedido,
        dtInicio,
        dtFim,
        produtos,
        nome,
        nPedido,
        vendedores,
        vendedorSelecionado,
        statusPagamentos,
        statusPagamentosSelecionado,
        statusPedidoSelecionado,
        linhasSelecionadas,
        onChangeFiltroStatusPedido,
        BuscarTodosPedidos,
        setDtInicio,
        setDtFim,
        setProdutos,
        setNome,
        setNPedido,
        setVendedores,
        setVendedorSelecionado,
        setStatusPagamentos,
        setLinhasSelecionadas,
        setStatusPagamentosSelecionado,
        handleSort,
        getSortIcon,
        showEditarStatusModal,
        handleShowEditarStatusModal,
        pedidoSelecionado,
        handleEditarStatusPedido,
        handleHideEditarStatusModal,
        showAssinaturaModal,
        pedidoAssinaturaSelecionado,
        handleShowAssinaturaModal,
        handleHideAssinaturaModal,
        carregando,
    };
}